import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { AveragePlayerScore } from '@sorare/core/src/__generated__/globalTypes';
import diamond from '@sorare/core/src/assets/animations/diamond.png';
import { withFragments } from '@sorare/core/src/lib/gql';

import { RuleHelperFnReturnType } from '../types';
import { getMinimumPlayersAverageScoreRule_so5Rules } from './__generated__/getMinimumPlayersAverageScoreRule.graphql';

export const getMinimumPlayersAverageScoreRule = withFragments(
  (
    rules: getMinimumPlayersAverageScoreRule_so5Rules,
    error: string
  ): RuleHelperFnReturnType => {
    const rule = rules.minimumPlayersAverageScore;
    if (!rule) {
      return null;
    }
    const { min, max, count, averageType } = rule!;
    const uniqueCondition = min ? 'greaterThan' : 'lessThan';
    const condition = min && max ? 'between' : uniqueCondition;
    return {
      id: 'minimumPlayersAverageScore',
      label: (
        <FormattedMessage
          id="Rules.minimumPlayersAverageScore.label"
          defaultMessage="Min {count, plural, one {# player} other {# players}} scoring"
          values={{ count }}
        />
      ),
      description: (
        <FormattedMessage
          id="Rules.minimumPlayersAverageScore.description"
          defaultMessage="an average {condition, select, between {between {min} and {max}} greaterThan {of {min} or above} other {of {max} or below}} in the last {games} games"
          values={{
            condition,
            min,
            max,
            games:
              averageType === AveragePlayerScore.LAST_FIVE_SO5_AVERAGE_SCORE
                ? 5
                : 15,
          }}
        />
      ),
      icon: <img src={diamond} alt="" width="16" height="16" />,
      error,
    };
  },
  {
    so5Rules: gql`
      fragment getMinimumPlayersAverageScoreRule_so5Rules on So5Rules {
        id
        minimumPlayersAverageScore {
          averageType
          count
          min
          max
        }
      }
    ` as TypedDocumentNode<getMinimumPlayersAverageScoreRule_so5Rules>,
  }
);
